export default __webpack_public_path__ + "static/custos1-e7a69ab96ff244e326c4e9a9b7258246.jpeg";